module.exports = __webpack_public_path__ + "img/frightened.22aa4596.svg";